import { render, staticRenderFns } from "./FriendCase.vue?vue&type=template&id=ca5ce258&scoped=true&"
import script from "./FriendCase.vue?vue&type=script&lang=js&"
export * from "./FriendCase.vue?vue&type=script&lang=js&"
import style0 from "@/assets/styles/beneficiary.css?vue&type=style&index=0&id=ca5ce258&prod&scoped=true&lang=css&"
import style1 from "./FriendCase.vue?vue&type=style&index=1&id=ca5ce258&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca5ce258",
  null
  
)

export default component.exports